export function BrandMark({ className = "" }) {
  return (
    <span className={`font-heading font-extrabold tracking-[0.12em] ${className}`}>
      <span className="brand-after">AFTER</span>
      <span className="brand-hello-stroke">HELLO</span>
    </span>
  );
}

export default function BrandHero({ className = "" }) {
  return (
    <div className={`text-center brand-fade ${className}`} data-testid="brand-hero">
      <h1 className="font-heading font-extrabold tracking-[0.14em] text-4xl sm:text-5xl lg:text-6xl flex items-center justify-center gap-2 flex-wrap leading-none">
        <span className="brand-after">AFTER</span>
        <span className="brand-hello-box">HELLO</span>
      </h1>
      <div className="neon-rail w-full max-w-xl mx-auto mt-6 rounded-full" />
      <p className="brand-quote italic text-sm sm:text-base mt-5 max-w-xl mx-auto">
        “Because real connections don't just happen at hello. Earn the trust, feel the vibe, unlock the unfiltered closeness.”
      </p>
    </div>
  );
}
